import { ServerDate } from "helpers/server-date.class"

export const isToday = (date: Date | string | number): boolean => {
  const today = new ServerDate()
  const dateToCheck = new ServerDate(date)

  return (
    dateToCheck.getUTCFullYear() === today.getUTCFullYear() &&
    dateToCheck.getUTCMonth() === today.getUTCMonth() &&
    dateToCheck.getUTCDate() === today.getUTCDate()
  )
}
